import React from 'react';
import { Content, Row, Col, Title, Button, HtmlContent } from 'components';
import Formatter from 'utils/Formatter';

const CouponEventDetailsPresenter = (props) => {
  /* ===== Props ===== */
  const { navigate, event, screenSize } = props;

  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 40 : 28,
      fontFamily: `"Dela Gothic One", sans-serif`,
      fontWeight: 400,
      fontStyle: 'normal',
      textTransform: 'capitalize',
    },
    button: {
      padding: '10px 29px',
      backgroundColor: 'transparent',
      border: '1px solid #ddd',
      color: 'var(--black-color)',
    },
    activeButton: {
      padding: '10px 29px',
      backgroundColor: 'var(--black-color)',
      color: 'white',
    },
  };

  return (
    <Content
      maxWidth={1820}
      padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
    >
      <Row gutter={25}>
        <Col x={0} md={4}></Col>
        <Col x={24} md={16}>
          <Content maxWidth={'100%'} padding={0}>
            <Title
              align={'center'}
              style={{
                ...styles.title,
                marginBottom: screenSize >= 768 ? 120 : 60,
              }}
            >
              JM Event
            </Title>

            {/* 제목 */}
            <div>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  padding: '32px 0',
                  borderBottom: '1px solid #ddd',
                  flexDirection: screenSize >= 768 ? 'unset' : 'column',
                  rowGap: 20,
                }}
              >
                <Title
                  style={{
                    fontSize: screenSize >= 768 ? 32 : 24,
                    fontWeight: 700,
                    marginLeft: screenSize >= 768 ? 24 : 0,
                  }}
                >
                  {event?.event_title}
                </Title>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'end',
                    fontSize: screenSize >= 768 ? 16 : 14,
                    minWidth: 'fit-content',
                  }}
                >
                  <div>
                    {Formatter.unixToDate(
                      event?.start_date,
                      'YYYY-MM-DD HH:MM'
                    )}{' '}
                    ~
                  </div>
                  {Formatter.unixToDate(event?.end_date, 'YYYY-MM-DD HH:MM')}
                </div>
              </div>
            </div>

            {/* 내용 */}
            <div
              style={{
                padding: screenSize >= 768 ? '40px 24px' : '40px 0',
                display: 'flex',
                flexDirection: 'column',
                gap: 40,
                borderBottom: '1px solid #ddd',
              }}
            >
              <HtmlContent content={event?.event_content} />
            </div>
            <div
              maxWidth={'100%'}
              padding={0}
              style={{
                display: 'flex',
                justifyContent: 'center',
                margin: '100px auto 80px',
              }}
            >
              <Button
                style={{
                  width: '20%',
                  minWidth: 120,
                  padding: screenSize >= 768 ? '18px 52px' : '10px 40px',
                  fontWeight: 700,
                  borderRadius: '2px',
                  backgroundColor: 'var(--white-color)',
                  color: 'var(--black-color)',
                  border: '1px solid var(--black-color)',
                }}
                onClick={() => navigate('/events')}
              >
                목록
              </Button>
            </div>
          </Content>
        </Col>
        <Col x={0} md={4}></Col>
      </Row>
    </Content>
  );
};

export default CouponEventDetailsPresenter;
